export default __webpack_public_path__ + "462dd233079504bfcb8b9982a3ba947d.svg";